// src/components/ProtectedRoute.jsx

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import ErrorBoundary from './ErrorBoundary';

const ProtectedRoute = ({ children }) => {
  // ★ 修正点: `currentUser` の代わりに `isAuthenticated` と `loading` を受け取ります。
  const { isAuthenticated, loading } = useAuth();

  // ★ 追加: 認証状態を確認中の場合、ローディング画面を表示します。
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // ★ 修正点: `isAuthenticated` が false ならログインページに移動させます。
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 認証されていれば、子コンポーネント（各ページ）を表示します。
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default ProtectedRoute;